import { render, staticRenderFns } from "./game-6.vue?vue&type=template&id=44d33b2e&scoped=true&"
import script from "./game-6.vue?vue&type=script&lang=js&"
export * from "./game-6.vue?vue&type=script&lang=js&"
import style0 from "./game-6.vue?vue&type=style&index=0&id=44d33b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d33b2e",
  null
  
)

export default component.exports